import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_CRM + name;
};

const SALES_FORECAST = "sales-forecast";
const SETTINGS = "/settings";
const ORDERS = "/orders";

const SHIPMENT_RULES = `shippment-rules`;
const PROMOTIONS = `promotions`;
const CUSTOMER_SEGMENTS = `customer-segments`;
const DELIVERTY_SETTINGS = `delivery-settings`;

const LEAD = `lead`;
const OPPORTUNITY = `opportunity`;
const QUOTATION = `quotation`;
const SALES_ORDER = `sales-orders`;
const DELIVERTY_ORDER = `delivery-orders`;
const CUSTOMER_RETURNS = `customer-returns`;
const FORMS = 'forms'
const CUSTOM_FORM = 'custom-form'
const TERMS_AND_CONDITIONS = 'terms-and-conditions'
const CUSTOMER_MANAGEMENT = "master-data/customer-management";

const PATHNAME_CRM_REPORTS = {
  SALES_ORDER_SUMMARY_REPORT: "/reports/sales-order-summary",
  SALES_INVOICE_SUMMARY_REPORT: "/reports/sales-invoice-summary",
  SALES_ORDER_DETAIL_REPORT: "/reports/sales-order-detail",
  SALES_INVOICE_DETAIL_REPORT: "/reports/sales-invoice-detail",
  SALES_BY_SALESPERSON_PERFORMANCE: "/reports/sales-by-salesperson-performance",
  PENDING_QUOTES_APPROVALS: "/reports/pending-quotes-approvals",
  SALES_RETURN_CREDIT_NOTE_REPORT: "/reports/sales-return-credit-note",
  REGIONAL_BRANCH_SALES_PERFORMANCE: "/reports/regional-branch-sales-performance",
  SALES_DISCOUNT_PROMOTION_ANALYSIS: "/reports/sales-discount-promotion-analysis",
  SALES_CHANNEL_ANALYSIS: "/reports/sales-channel-analysis",
  ORDER_FULFILLMENT_DELIVERY_REPORT: "/reports/order-fulfillment-delivery",
  SALES_COMMISSION_INCENTIVE_REPORT: "/reports/sales-commission-incentive",
  SALES_BY_PRODUCT_SERVICE_REPORT: "/reports/sales-by-product-service",
  CUSTOMER_CHURN_RETENTION_REPORT: "/reports/customer-churn-retention",
};

export const salesForecastCrudPaths = {
  ADD_SALES_FORECAST: `/${SALES_FORECAST}/add-${SALES_FORECAST}`,
  EDIT_SALES_FORECAST: `/${SALES_FORECAST}/:id/edit-${SALES_FORECAST}`,
  VIEW_SALES_FORECAST: `/${SALES_FORECAST}/:id/view-${SALES_FORECAST}`,
};
export const salesForecastPaths = {
  SALES_FORECAST: `/${SALES_FORECAST}`,
  ...salesForecastCrudPaths,
};

// Settings Paths
export const shipmentRulesCrudPaths = {
  ADD_SHIPMENT_RULES: `${SETTINGS}/${SHIPMENT_RULES}/add-${SHIPMENT_RULES}`,
  EDIT_SHIPMENT_RULES: `${SETTINGS}/${SHIPMENT_RULES}/:id/edit-${SHIPMENT_RULES}`,
  VIEW_SHIPMENT_RULES: `${SETTINGS}/${SHIPMENT_RULES}/:id/view-${SHIPMENT_RULES}`,
};
export const promotionsCrudPaths = {
  ADD_PROMOTIONS: `${SETTINGS}/${PROMOTIONS}/add-${PROMOTIONS}`,
  EDIT_PROMOTIONS: `${SETTINGS}/${PROMOTIONS}/:id/edit-${PROMOTIONS}`,
  VIEW_PROMOTIONS: `${SETTINGS}/${PROMOTIONS}/:id/view-${PROMOTIONS}`,
};
export const customerSegmentsCrudPaths = {
  ADD_CUSTOMER_SEGMENTS: `${SETTINGS}/${CUSTOMER_SEGMENTS}/add-${CUSTOMER_SEGMENTS}`,
  EDIT_CUSTOMER_SEGMENTS: `${SETTINGS}/${CUSTOMER_SEGMENTS}/:id/edit-${CUSTOMER_SEGMENTS}`,
  VIEW_CUSTOMER_SEGMENTS: `${SETTINGS}/${CUSTOMER_SEGMENTS}/:id/view-${CUSTOMER_SEGMENTS}`,
};
export const deliverySettingsCrudPaths = {
  ADD_DELIVERTY_SETTINGS: `${SETTINGS}/${DELIVERTY_SETTINGS}/add-${DELIVERTY_SETTINGS}`,
  EDIT_DELIVERTY_SETTINGS: `${SETTINGS}/${DELIVERTY_SETTINGS}/:id/edit-${DELIVERTY_SETTINGS}`,
  VIEW_DELIVERTY_SETTINGS: `${SETTINGS}/${DELIVERTY_SETTINGS}/:id/view-${DELIVERTY_SETTINGS}`,
};

export const customFormPath = {
  CUSTOM_FORM: `${SETTINGS}/${CUSTOM_FORM}`,
};

export const shipmentRulesPaths = {
  SHIPMENT_RULES: `${SETTINGS}/${SHIPMENT_RULES}`,
  ...shipmentRulesCrudPaths,
};
export const promotionsPaths = {
  PROMOTIONS: `${SETTINGS}/${PROMOTIONS}`,
  ...promotionsCrudPaths,
};
export const customerSegmentsPaths = {
  CUSTOMER_SEGMENTS: `${SETTINGS}/${CUSTOMER_SEGMENTS}`,
  ...customerSegmentsCrudPaths,
};
export const deliverySettingsPaths = {
  DELIVERTY_SETTINGS: `${SETTINGS}/${DELIVERTY_SETTINGS}`,
  ...deliverySettingsCrudPaths,
};

export const formSettingsPaths = {
  FORMS: `${SETTINGS}/${FORMS}`,
  ...customFormPath
}

export const termsAndConditionsCrudPaths = {
  ADD_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/add-${TERMS_AND_CONDITIONS}`,
  EDIT_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/:id/edit-${TERMS_AND_CONDITIONS}`,
  VIEW_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/:id/view-${TERMS_AND_CONDITIONS}`,
};

export const termsAndConditionsPaths = {
  TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}`,
  ...termsAndConditionsCrudPaths,
};

const settingsRoutes = {
  ...shipmentRulesPaths,
  ...promotionsPaths,
  ...customerSegmentsPaths,
  ...deliverySettingsPaths,
  ...formSettingsPaths,
  ...termsAndConditionsPaths
};

// Orders Paths
export const leadCrudPaths = {
  ADD_LEAD: `${ORDERS}/${LEAD}/add-${LEAD}`,
  EDIT_LEAD: `${ORDERS}/${LEAD}/:id/edit-${LEAD}`,
  VIEW_LEAD: `${ORDERS}/${LEAD}/:id/view-${LEAD}`,
  LEAD_CALENDAR: `${ORDERS}/${LEAD}/view-${LEAD}/calendar`,
};
export const opportunityCrudPaths = {
  ADD_OPPORTUNITY: `${ORDERS}/${OPPORTUNITY}/add-${OPPORTUNITY}`,
  EDIT_OPPORTUNITY: `${ORDERS}/${OPPORTUNITY}/:id/edit-${OPPORTUNITY}`,
  VIEW_OPPORTUNITY: `${ORDERS}/${OPPORTUNITY}/:id/view-${OPPORTUNITY}`,
  VIEW_SALES_PIPELINE: `${ORDERS}/${OPPORTUNITY}/sales-pipeline`,
  OPPORTUNITY_CALENDAR: `${ORDERS}/${OPPORTUNITY}/view-${OPPORTUNITY}/calendar`,
};
export const quotationCrudPaths = {
  ADD_QUOTATION: `${ORDERS}/${QUOTATION}/add-${QUOTATION}`,
  EDIT_QUOTATION: `${ORDERS}/${QUOTATION}/:id/edit-${QUOTATION}`,
  VIEW_QUOTATION: `${ORDERS}/${QUOTATION}/:id/view-${QUOTATION}`,
  VIEW_REVISION: `${ORDERS}/${QUOTATION}/:id/view-Revision`,
};
export const salesOrderCrudPaths = {
  ADD_SALES_ORDER: `${ORDERS}/${SALES_ORDER}/add-${SALES_ORDER}`,
  EDIT_SALES_ORDER: `${ORDERS}/${SALES_ORDER}/:id/edit-${SALES_ORDER}`,
  VIEW_SALES_ORDER: `${ORDERS}/${SALES_ORDER}/:id/view-${SALES_ORDER}`,
};
export const deliveryOrderCrudPaths = {
  ADD_DELIVERTY_ORDER: `${ORDERS}/${DELIVERTY_ORDER}/add-${DELIVERTY_ORDER}`,
  EDIT_DELIVERTY_ORDER: `${ORDERS}/${DELIVERTY_ORDER}/:id/edit-${DELIVERTY_ORDER}`,
  VIEW_DELIVERTY_ORDER: `${ORDERS}/${DELIVERTY_ORDER}/:id/view-${DELIVERTY_ORDER}`,
};
export const customerReturnsCrudPaths = {
  ADD_CUSTOMER_RETURNS: `${ORDERS}/${CUSTOMER_RETURNS}/add-${CUSTOMER_RETURNS}`,
  EDIT_CUSTOMER_RETURNS: `${ORDERS}/${CUSTOMER_RETURNS}/:id/edit-${CUSTOMER_RETURNS}`,
  VIEW_CUSTOMER_RETURNS: `${ORDERS}/${CUSTOMER_RETURNS}/:id/view-${CUSTOMER_RETURNS}`,
  VIEW_GRN_REPORT: `${ORDERS}/${CUSTOMER_RETURNS}/:id/view-Grn`,
  GRN_NOTES: `${ORDERS}/${CUSTOMER_RETURNS}/Grn`,
  ADD_GRN_NOTE: `${ORDERS}/${CUSTOMER_RETURNS}/add-Grn`,
  EDIT_GRN_NOTE: `${ORDERS}/${CUSTOMER_RETURNS}/:id/edit-Grn`,
};
export const leadPaths = {
  LEAD: `${ORDERS}/${LEAD}`,
  ...leadCrudPaths,
};
export const opportunityPaths = {
  OPPORTUNITY: `${ORDERS}/${OPPORTUNITY}`,
  ...opportunityCrudPaths,
};
export const quotationPaths = {
  QUOTATION: `${ORDERS}/${QUOTATION}`,
  ...quotationCrudPaths,
};
export const salesOrderPaths = {
  SALES_ORDER: `${ORDERS}/${SALES_ORDER}`,
  ...salesOrderCrudPaths,
};
export const deliveryOrderPaths = {
  DELIVERTY_ORDER: `${ORDERS}/${DELIVERTY_ORDER}`,
  ...deliveryOrderCrudPaths,
};
export const customerReturnsPaths = {
  CUSTOMER_RETURNS: `${ORDERS}/${CUSTOMER_RETURNS}`,
  ...customerReturnsCrudPaths,
};
const orderRoutes = {
  ...leadPaths,
  ...opportunityPaths,
  ...quotationPaths,
  ...salesOrderPaths,
  ...deliveryOrderPaths,
  ...customerReturnsPaths,
};

export const customerManagementPaths = {
  CUSTOMER_MANAGEMENT: `/${CUSTOMER_MANAGEMENT}`,
};

export const PathnameCrm = {
  LANDING_PAGE: "/",
  LIST: "/list",
  REPORTS: "/reports",
  ...PATHNAME_CRM_REPORTS,
  ...salesForecastPaths,
  ...settingsRoutes,
  ...orderRoutes,
  ...customerManagementPaths,
};